import { render } from "./TSATelemetryDrone.vue?vue&type=template&id=1bc11a04&scoped=true"
import script from "./TSATelemetryDrone.vue?vue&type=script&lang=js"
export * from "./TSATelemetryDrone.vue?vue&type=script&lang=js"

import "./TSATelemetryDrone.vue?vue&type=style&index=0&id=1bc11a04&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc11a04"]])

export default __exports__